
export default function Company() {
  return (
    <section id="company" className="py-12 bg-[#112240]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          運営会社について
        </h2>
        <div className="max-w-3xl mx-auto text-slate-300 space-y-3 text-sm md:text-base leading-relaxed text-center">
          <p>
            プロジェクトマスターは
            AtZBusinessPartners株式会社が運営しています。
          </p>
          <p>
            DX・戦略コンサルティングを中心に
            大手企業向けの支援を行っています。
          </p>
          <div className="mt-4 text-center">
            <a 
              href="https://atz-bp.co.jp/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-6 py-2 bg-amber-500 text-[#0a1628] font-semibold rounded-lg hover:bg-amber-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              会社サイトを見る
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}